import { render } from "./OrderListPage.vue?vue&type=template&id=4b825328"
import script from "./OrderListPage.vue?vue&type=script&lang=ts"
export * from "./OrderListPage.vue?vue&type=script&lang=ts"
script.render = render

export default script